import { render, staticRenderFns } from "./AvatarMedium.vue?vue&type=template&id=39b862c4"
import script from "./AvatarMedium.vue?vue&type=script&lang=js"
export * from "./AvatarMedium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports